import type { NuxtError } from "#app";

export function use404Response(error: MaybeRef<NuxtError | null>) {
  const nuxtApp = useNuxtApp();
  nuxtApp.runWithContext(() => {
    const event = useRequestEvent();
    if (unref(error) && event) {
      setResponseStatus(event, 404);
    }
  });
}
